import * as React from "react";
import { useTranslation } from "@elevio/kb-kit/lib/hooks";
import * as Category from "@elevio/kb-kit/lib/components/category";
import * as Search from "@elevio/kb-kit/lib/components/search";
import * as Article from "@elevio/kb-kit/lib/components/article";
import * as Articles from "@elevio/kb-kit/lib/components/articles";
import { getAssetURL } from "@elevio/kb-kit/lib/utils/globals";
import { getHeader } from "./home";
import PageLayout from "../components/layouts/Page";
import Footer from "../components/Footer";
import WithAsideLayout, { Aside, Main, MainHeader, MainBody, } from "../components/layouts/WithAside";
import CategoryList from "../components/CategoryList";
import { fetchAgencyFlags } from "../requests/agency-flags";
import { privateSubmissionUrl } from "../utils/privateSubmissionUrl";
const AGENCY_ID = 91;
function Page() {
    const { t } = useTranslation();
    const [showViewAllRequests, setShowViewAllRequests] = React.useState(false);
    React.useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const openPrivateSubmission = (path) => {
        const url = privateSubmissionUrl(path);
        if (!url) {
            return;
        }
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
            newWindow.opener = null;
        }
    };
    const handleSubmitRequest = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("create");
    };
    const handleViewMyRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("listing");
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("public-map");
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      {/* <div className="ask-arvada-logo-wrapper">
          <img className="ask-arvada-logo" src={brandShowcaseUrl} alt="ask-agency-logo-wrapper-image"/>
        </div> */}
      <section className="button-container button-container--three">
        <div className="button-wrapper">
          <button type="button" className="cta-request" onClick={handleSubmitRequest}>
            <img src={getAssetURL("images/request.svg")} alt="request icon" aria-hidden/>
            Submit a Request
          </button>
        </div>
        <div className="button-wrapper">
          <button type="button" className="cta-request" onClick={handleViewMyRequests}>
            <img src={getAssetURL("images/inbox.svg")} alt="inbox icon" aria-hidden/>
            View My Requests
          </button>
        </div>
        {showViewAllRequests ? (<div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleViewAllRequests}>
              <img src={getAssetURL("images/map.svg")} alt="map icon" aria-hidden/>
              View All Requests
            </button>
          </div>) : null}
      </section>
      <WithAsideLayout>
        <Main>
          <MainHeader>
            <h1 className="main-title" data-testid="category-title">
              <Category.Title />
            </h1>
          </MainHeader>

          <MainBody data-testid="category-body">
            <Articles.Loop>
              <Article.Link className="article-link link-color" data-testid="article-link">
                <div id="unique-id-2">
                  <h2 className="article-link-title">
                    <Article.Title />
                  </h2>
                  <div id="article-link-summary" className="article-link-summary">
                    <Article.Summary />
                  </div>
                </div>
              </Article.Link>
            </Articles.Loop>
          </MainBody>
        </Main>

        <Aside>
          <Search.Input className="sidebar-search" placeholder={t("search.shortplaceholder", "Search...")} data-testid="category-search-input"/>
          <CategoryList />
        </Aside>
      </WithAsideLayout>
    </PageLayout>);
}
export default Page;
